import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { LinearProgress } from 'beam/dist/Progress'
import { MuiPickersProvider } from 'beam/dist/MuiPickers'
import { Suspense } from 'react'
import { HeadProvider } from 'react-head'
import { Provider } from 'react-redux'
import { App } from './App'
import { ConeRouter } from './Common/ConeRouter'
import { ThemeProvider } from './Common/ThemeProvider'
import { store } from './configureStore'
import { Routes } from './routes'
import i18n from './i18n'
import { YupProvider } from './i18n/yupProvider'
import { I18nextProvider } from 'react-i18next'
import { L10nProvider } from './L10nProvider'

const cache = createCache({
  key: 'cone',
  nonce: document.getElementById('main-script')?.nonce,
})

export const Root = () => (
  <Suspense fallback={<LinearProgress />}>
    <Provider store={store}>
      <HeadProvider>
        <CacheProvider value={cache}>
          <ThemeProvider>
            <MuiPickersProvider>
              <I18nextProvider i18n={i18n}>
                <L10nProvider>
                  <YupProvider>
                    <ConeRouter>
                      <App>
                        <Routes />
                      </App>
                    </ConeRouter>
                  </YupProvider>
                </L10nProvider>
              </I18nextProvider>
            </MuiPickersProvider>
          </ThemeProvider>
        </CacheProvider>
      </HeadProvider>
    </Provider>
  </Suspense>
)
